import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-chip', 'close', 'Aizvērt');
